(() => {
  const endpoint = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  const root = document.currentScript?.previousElementSibling;

  if (!root) return;

  /** @type {HTMLFormElement|null} */
  const form = root.querySelector('[data-klaviyo-signup-form]');
  if (!form || form.dataset.initialized === 'true') return;

  form.dataset.initialized = 'true';

  const fieldInputs = [...form.querySelectorAll('input[data-form-field]')].filter(
    (input) => input instanceof HTMLInputElement
  );
  const emailInput = fieldInputs.find((input) => input.dataset.formField === 'email');
  /** @type {HTMLElement|null} */
  const message = form.querySelector('[data-klaviyo-signup-message]');
  /** @type {HTMLButtonElement|null} */
  const submitButton = form.querySelector('button[type="submit"]');
  const listId = form.dataset.listId;
  const successMessage = form.dataset.successMessage || 'Thanks for subscribing!';

  if (!emailInput || !submitButton || !listId) return;

  /**
   * @param {string} text
   * @param {boolean} [isError=false]
   */
  const setMessage = (text, isError = false) => {
    if (!message) return;

    message.textContent = text;
    message.hidden = false;
    message.classList.toggle('klaviyo-sign-up__message--error', isError);
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const email = emailInput.value.trim();
    if (!email) {
      setMessage('Please enter your email address.', true);
      return;
    }

    submitButton.disabled = true;

    try {
      const params = new URLSearchParams();
      const customFields = [];

      for (const input of fieldInputs) {
        const key = input.dataset.formField;
        if (!key) continue;

        const value = input.value.trim();
        const normalizedKey = key.toLowerCase();
        const payloadKey = normalizedKey === 'tel' || normalizedKey === 'phone' ? 'phone_number' : key;

        if (normalizedKey === 'email') {
          params.append('email', value);
          continue;
        }

        if (!value) continue;

        params.append(payloadKey, value);
        customFields.push(payloadKey);
      }

      params.append('$fields', customFields.join(','));
      params.append('g', listId);

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache'
        },
        body: params
      });

      const data = await response.json();
      const hasErrors = data?.errors && Array.isArray(data.errors) && data.errors.length > 0;

      if (hasErrors) {
        setMessage('Subscription failed. Please try again.', true);
        return;
      }

      for (const input of fieldInputs) {
        input.value = '';
      }

      setMessage(successMessage);
    } catch (_error) {
      setMessage('Subscription failed. Please try again.', true);
    } finally {
      submitButton.disabled = false;
    }
  });
})();
